import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function ccr3(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@ccr3/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr3/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr3/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@ccr3/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr3/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr3/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}